class hero{
    constructor(){
        console.log('hello')
    }
}
new hero();